module.exports = __webpack_public_path__ + "img/farzana-christopher-91.9353d3b7.jpg";